//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex'
import Button from '@/components/Shared/Button.vue'
import PROJECT_ROLES from '@/constants/project-roles'
import Multiselect from 'vue-multiselect'
import MessageWithoutHeader from '@/components/Shared/MessageWithoutHeader.vue'
import NewProjectsWizardButtons from '@/components/Projects/NewProjectWizardButtons.vue'
import SupervisorAssignmentSelect from '@/components/Projects/NewProjectSteps/StepSupervisorCollaborator/SupervisorAssignmentSelect.vue'
import ModalMassiveSupervisorAssignment from '@/components/Projects/NewProjectSteps/StepSupervisorCollaborator/ModalMassiveSupervisorAssignment.vue'
import PROJECT_VALIDATION_STATUS from '~/constants/project-validation-status'
export default {
  name: 'StepSupervisorAssignment',
  components: {
    Button,
    Multiselect,
    NewProjectsWizardButtons,
    MessageWithoutHeader,
    SupervisorAssignmentSelect,
    ModalMassiveSupervisorAssignment,
  },
  filters: {
    fullNames(user) {
      return `${user?.names} ${user?.lastnames}`
    },
  },
  async fetch() {
    this.$store.commit('loading', true)
    await this.getSupervisorAssignmentsInProject()
    this.supervisors = await this.$repository.user.findSupervisorsByProject({
      project: this.getBaseProject.id,
    })
    this.setSupervisors(this.supervisors)
    this.$store.commit('loading', false)
  },
  data() {
    return {
      employeeTypesList: [
        { value: PROJECT_ROLES.COLLABORATOR, label: 'Colaborador' },
        { value: PROJECT_ROLES.SUPERVISOR, label: 'Supervisor' },
      ],
      filters: {
        term: '',
        itemsPerPage: 10,
        supervisor: null,
      },
      currentPage: 1,
      supervisorAssignments: [],
      supervisors: [],
      checkedRows: [],
      isShowMassiveSupervisorAssignmentModal: false,
      checkAllRows: false,
    }
  },
  computed: {
    ...mapGetters({
      getBaseProject: 'project/getBaseProject',
    }),
    supervisorsFormatted() {
      return this.supervisors.map((supervisor) => ({
        value: supervisor.id,
        label: `${supervisor.names} ${supervisor.lastnames}`,
      }))
    },
    filteredSupervisorAssignments() {
      return this.supervisorAssignments.filter((assignment) => {
        const matchesTerm = assignment.collaborator
          ? `${assignment.collaborator.names} ${assignment.collaborator.lastnames}`
              .toLowerCase()
              .includes(this.filters.term.toLowerCase())
          : false
        const matchesSupervisor =
          !this.filters.supervisor ||
          (assignment.supervisor &&
            assignment.supervisor.id === this.filters.supervisor.value)
        return matchesTerm && matchesSupervisor
      })
    },
    enableNextStep() {
      const emptySupervisors = this.supervisorAssignments.filter(
        (supervisorAssignment) => {
          return supervisorAssignment.supervisor === null
        }
      )
      return emptySupervisors.length === 0
    },
  },
  watch: {
    checkAllRows(newValue) {
      if (newValue) {
        if (
          this.$refs.mySupervisorAssignmentTable &&
          this.$refs.mySupervisorAssignmentTable.newData
        ) {
          const startIndex =
            (this.currentPage - 1) * Number(this.filters.itemsPerPage)
          const endIndex = startIndex + Number(this.filters.itemsPerPage)

          const rowsOnCurrentPage = this.$refs.mySupervisorAssignmentTable.newData.slice(
            startIndex,
            endIndex
          )

          this.checkedRows = [
            ...rowsOnCurrentPage.filter((row) => row.supervisor === null),
          ]
        }
      } else {
        this.checkedRows = []
      }
    },
  },
  methods: {
    ...mapActions({
      setSupervisors: 'project/setSupervisors',
    }),
    handleBack() {
      this.$emit('back')
    },
    handleContinue() {
      this.$emit('next')
    },
    generateComposeId(supervisorAssignment) {
      if (supervisorAssignment.supervisor === null) {
        return `${supervisorAssignment.id}-${supervisorAssignment.collaborator.id}`
      }
      return `${supervisorAssignment.id}-${supervisorAssignment.collaborator.id}-${supervisorAssignment.supervisor.id}`
    },
    async getSupervisorAssignmentsInProject() {
      try {
        this.$store.commit('loading', true)
        this.supervisorAssignments = await this.$repository.projectRoles.findWithSupervisorAssignmentByProjectId(
          this.getBaseProject.id
        )
      } catch (error) {
        this.$buefy.notification.open({
          message:
            'No se pudieron obtener las asignaciones de supervisores del proyecto.',
          type: 'is-danger',
          hasIcon: true,
          duration: 5000,
        })
      } finally {
        this.$store.commit('loading', false)
      }
    },
    supevisorRowFormat(row) {
      if (!row.supervisor) {
        return null
      }
      return {
        value: row.supervisor?.id,
        label: `${row.supervisor?.names} ${row.supervisor?.lastnames}`,
      }
    },
    async handleSelectSupervisor({ supervisorId, projectId, collaboratorId }) {
      try {
        await this.$repository.supervisorAssignments.saveMassiveCollaborators({
          collaboratorsIds: [collaboratorId],
          supervisorId,
          projectId,
          validationStatus: PROJECT_VALIDATION_STATUS.PENDING,
        })
        this.$buefy.notification.open({
          message: 'Supervisor asignado correctamente.',
          type: 'is-success',
          hasIcon: true,
          duration: 5000,
        })
        await this.getSupervisorAssignmentsInProject()
      } catch (error) {
        this.$buefy.notification.open({
          message: 'Error al asignar el supervisor.',
          type: 'is-danger',
          hasIcon: true,
          duration: 5000,
        })
      }
    },
    async handleMassiveSupervisorAssignment(supervisor) {
      try {
        this.$store.commit('loading', true)
        const collaboratorsIds = this.checkedRows.map(
          (row) => row.collaborator.id
        )
        await this.$repository.supervisorAssignments.saveMassiveCollaborators({
          collaboratorsIds,
          supervisorId: supervisor.value,
          projectId: this.getBaseProject.id,
          validationStatus: PROJECT_VALIDATION_STATUS.PENDING,
        })
        this.$buefy.notification.open({
          message: 'Supervisores asignados correctamente.',
          type: 'is-success',
          hasIcon: true,
          duration: 5000,
        })
        await this.getSupervisorAssignmentsInProject()
      } catch (error) {
        this.$buefy.notification.open({
          message: 'Error al asignar los supervisores masivamente.',
          type: 'is-danger',
          hasIcon: true,
          duration: 5000,
        })
      } finally {
        this.isShowMassiveSupervisorAssignmentModal = false
        this.$store.commit('loading', false)
      }
    },
    toggleMassiveSupervisorAssignmentModal() {
      this.isShowMassiveSupervisorAssignmentModal = !this
        .isShowMassiveSupervisorAssignmentModal
    },
  },
}
